import { render, staticRenderFns } from "./sysuser_list.vue?vue&type=template&id=37f4d9ba&scoped=true"
import script from "./sysuser_list.vue?vue&type=script&lang=js"
export * from "./sysuser_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4d9ba",
  null
  
)

export default component.exports